module.exports = __webpack_public_path__ + "static/media/default-cover-photo.3ca87e58.png";